import { DOMAIN } from '../../../../../var_env.'
import { RequestResponsePattern } from '../../../../../types/Request'
import { ClienteType } from '../../Parametro/Types/ClienteType'
import { getApi } from '../../../../../utils/requestApi'

export default async function getMonitoramentoFrequente(): Promise<ClienteType[]> {
    const endpoint = DOMAIN
    const params = `/pessoa-monitoramento-frequente`

    const response: RequestResponsePattern<ClienteType[]> = await getApi({ endpoint, params })

    if (response) {
        if (!response.flagErro) {
            return response.listaResultados
        }
        throw new Error(response.listaMensagens[0])
    }
    return []
}


